module.exports = __webpack_public_path__ + "static/media/floating-solution-tube-rack-empty.29775082.svg";